import { ISO } from '@doxyme/extensions-graphql-types';

export const getRegistryCompatibleISO = (locale: string) => {
  /* Convert the locale format to ensure compatibility with the extension registry API.

  There are three ways to switch the locale in the project at the moment:
  1. The browser's preferred locale (e.g., via Chrome settings) is stored in
     a hyphenated format (e.g., "en-GB"). We can't control this format as it's
     a native browser behavior.
  2. The language can be changed via a URL query parameter (`l`), e.g.,
     `https://doxy.me/v2/account/dashboard?l=en-GB`.
  3. It can also be changed programmatically (using `useLocale`)

  However, our backend only supports ISO codes with an underscore format (e.g., "en_GB").
  Additionally, we currently have only two supported locales with country suffixes: "zh_CN" and "zh_TW".

  To ensure compatibility:
  - We first replace hyphens with underscores.
  - If the transformed value exists in the list of supported ISO codes, we use it.
  - Otherwise, we fallback to using only the language prefix (e.g., "en" from "en-GB").
  - Any further fallbacks to the default ISO format are handled on the backend. */

  const underscoredLocale = locale.replace('-', '_');

  if (Object.values(ISO).includes(underscoredLocale as ISO)) {
    return underscoredLocale;
  }

  return underscoredLocale.split('_')[0];
};
